export const SearchStuffModel = {
    fieldNames: [],
    fieldValue: ''
}
